import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, LOCALES, LOCALE_TAGS, pickLocaleFromAcceptLanguage, type Locale } from '@jisy/shared';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';

/**
 * Языки интерфейса. Русский собран по текстам макета и служит эталоном, остальные переведены
 * с него. Названия статусов, типов и приоритетов приходят из Jira и не переводятся: они
 * настраиваются в конкретном проекте, и подмена их своими словами только запутает.
 */

const resources = {
  ru: { translation: ru },
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
} as const;

/** До первого ответа сервера берём язык браузера. */
function initialLocale(): Locale {
  const stored = window.localStorage.getItem('jisy.locale');
  if (stored && (LOCALES as readonly string[]).includes(stored)) return stored as Locale;
  return pickLocaleFromAcceptLanguage(navigator.languages.join(',')) ?? DEFAULT_LOCALE;
}

void i18n.use(initReactI18next).init({
  resources,
  lng: initialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [...LOCALES],
  interpolation: {
    // React экранирует сам, двойное экранирование ломает кавычки и тире в текстах.
    escapeValue: false,
  },
});

export function setLocale(locale: Locale): void {
  void i18n.changeLanguage(locale);
  window.localStorage.setItem('jisy.locale', locale);
  document.documentElement.lang = LOCALE_TAGS[locale];
}

export function currentLocale(): Locale {
  const language = i18n.language as Locale;
  return (LOCALES as readonly string[]).includes(language) ? language : DEFAULT_LOCALE;
}

export function localeTag(): string {
  return LOCALE_TAGS[currentLocale()];
}

export { i18n };
